import { render, staticRenderFns } from "./SingleAnswerWithTextbox.vue?vue&type=template&id=b125aaee&"
import script from "./SingleAnswerWithTextbox.vue?vue&type=script&lang=js&"
export * from "./SingleAnswerWithTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports